import { Component, ElementRef, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationService } from "src/app/Service/notification.service";
import { OtherService } from "src/app/Service/other.service";
import { registerables } from 'chart.js';
import { Location } from '@angular/common';
import { DragRotateAndZoom, defaults as defaultInteractions } from 'ol/interaction';
import { Tile as TileLayer } from 'ol/layer';
import { Point } from "ol/geom";
import { BingMaps, Cluster, Vector, XYZ } from "ol/source";
import { Tile } from "ol/layer";
import { MapService } from "src/app/Service/map.service";
import { DeviceDetectorService } from "ngx-device-detector";
import { Circle, Fill, Stroke, Style, Text } from "ol/style";
import { getRelativePosition } from 'chart.js/helpers';
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { DataService } from "src/app/Service/data.service";
import { GurdServiceService } from "src/app/Service/gurd-service.service";
import "ol/ol.css";
import Map from 'ol/Map';
import View from 'ol/View';
import VectorLayer from 'ol/layer/Vector';
import Feature from 'ol/Feature';
import OSM from 'ol/source/OSM';
import Chart from 'chart.js/auto';
import axios from "src/app/Service/axios";
import AnimatedCluster from "ol-ext/layer/AnimatedCluster";
import SelectCluster from "ol-ext/interaction/SelectCluster";
import zoomPlugin from 'chartjs-plugin-zoom';
import momentJalaali from "moment-jalaali";
import * as olProj from 'ol/proj';
import * as XLSX from 'xlsx';
import { map, Observable, of } from "rxjs";
import VectorSource from "ol/source/Vector";
declare let $: any;

@Component({

  selector: 'app-fisheries-dashbord',

  templateUrl: './fisheries-dashbord.component.html',

  styleUrls: ['./fisheries-dashbord.component.css']

})

export class FisheriesDashbordComponent implements OnInit {

  location: any = [51.3833554, 35.6770113];

  map: any = {};

  ctx1: any;

  ctx2: any;

  ctx3: any;

  obj1: any;

  obj2: any;

  obj3: any;

  label1: Array<any> = [];

  label2: Array<any> = [];

  label3: Array<any> = [];

  datachart1: Array<any> = [];

  datachart2: Array<any> = [];

  datachart3: Array<any> = [];

  tiMobileType: any = -1;

  iMobileDomain: number = -1;

  domain: any;

  groupCar: any = [];

  dataFrom: FormGroup = this.formBuilder.group({

    date: new Date().valueOf(),

  });

  dataTo: FormGroup = this.formBuilder.group({

    date: new Date().valueOf(),

  });

  strSTime: FormControl = new FormControl("00:00");

  strETime: FormControl = new FormControl("23:59");

  CHART_COLORS3: any = {
    green: 'rgb(111, 255, 111)',
    purple: 'rgb(255, 153, 204)',
    blue: 'rgb(29, 179, 214)',
    orange: 'rgb(45, 103, 103)',
    yellow: 'rgb(251, 101, 150)',
    red: 'rgb(36, 123, 46)',
    grey: 'rgb(103, 13, 183)',
  };

  options!: Observable<any>;

  options1!: Observable<any>;

  source: any;

  vector: any;

  layers: any = [];

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(

    private notifyService: NotificationService,

    private router: Router,

    private otherService: OtherService,

    private el: ElementRef,

    private _location: Location,

    private mapService: MapService,

    private deviceService: DeviceDetectorService,

    private route: ActivatedRoute,

    private formBuilder: FormBuilder,

    private dataService: DataService,

    private gurdService: GurdServiceService

  ) {

    Chart.register(...registerables), Chart.register(zoomPlugin)

  }

  ngOnInit(): void {

    this.getDomain();

    this.getGroup();

    this.search();

  }

  getDomain = async () => {

    const resp = await axios.post(`GetMobileDomain4Report?iSystemUser=${this.gurdService.decrypt(localStorage.getItem("ID")!)}`, {});

    this.domain = JSON.parse(resp.data);

    if (this.iMobileDomain) {

      setTimeout(() => {

        $("#domainDashbord").val(Number(this.iMobileDomain));

      }, 100);
    }
    if (this.tiMobileType) {

      setTimeout(() => {

        $("#carGroup").val(Number(this.tiMobileType));

      }, 100);

    }

  }

  getGroup = async () => {

    const resp = await axios.post(`GetMobileType`, {});

    this.groupCar = resp.data;

  }

  async search() {

    this.otherService.Showspinner();

    await this.loadTree1('Boat_Statistics');

    await this.loadTree2('Boat_Status');

    await this.getMobilesFullReport();

    await this.getBoat_Prolific();

    await this.getPowerStatus();

    await this.initializeMap();

    this.otherService.nonespinner();

  }

  loadTree1 = async (api: any) => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;


    model.iMobileDomain = this.iMobileDomain;

    model.tiMobileType = this.tiMobileType;

    model.strSDate = this.dataFrom.controls["date"].value;

    model.strEDate = this.dataTo.controls["date"].value;

    model.strSTime = $("#Stime").val();

    model.strETime = $("#Etime").val();

    this.otherService.Showspinner();
    const resp = await axios.post(`${api}`, model);
    this.otherService.nonespinner();
    this.options = of(resp.data)
      .pipe(
        map((data: any) => {
          let res = JSON.parse(data.toString());
          let not = 0;
          res.children.forEach((element: any) => {
            not += element.children.length
          });

          if (not > 50) {
            let can = document.getElementById('totalVehicles') as HTMLElement;
            can.style.height = '700px'
          }


          res.children.forEach(function (datum: any, index: number) {
            index % 1 === 0 && (datum.collapsed = true);
          });
          return {
            tooltip: {
              trigger: 'item',
              triggerOn: 'mousemove',
              responsive: true,
              textStyle: {
                color: '#000',
                fontFamily: 'vazir',
                fontSize: 12
              },
              formatter: function (params: any) {
                return `تعداد ${new Number(params.data.value).toLocaleString('fa-ir')} زیر مجموعه`
              }
            },
            series: [
              {
                type: 'tree',
                data: [res],
                top: '1%',
                left: '10%',
                responsive: true,
                bottom: '5%',
                right: '20%',
                symbolSize: 10,
                label: {
                  position: 'left',
                  fontFamily: 'vazir',
                  verticalAlign: 'middle',
                  align: 'right',
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#000',
                },
                leaves: {
                  label: {
                    position: 'right',
                    verticalAlign: 'middle',
                    align: 'left',
                    color: '#000'
                  },
                },
                expandAndCollapse: true,
                animationDuration: 550,
                animationDurationUpdate: 750,
              },
            ],
          };
        }),
      );
  }

  loadTree2 = async (api: any) => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;


    model.iMobileDomain = this.iMobileDomain;

    model.tiMobileType = this.tiMobileType;

    model.strSDate = this.dataFrom.controls["date"].value;

    model.strEDate = this.dataTo.controls["date"].value;

    model.strSTime = $("#Stime").val();

    model.strETime = $("#Etime").val();
    this.otherService.Showspinner();
    const resp = await axios.post(`${api}`, model);
    this.otherService.nonespinner();
    this.options1 = of(resp.data)
      .pipe(
        map((data: any) => {
          let res = JSON.parse(data.toString());
          let not = 0;
          res.children.forEach((element: any) => {
            not += element.children.length
          });

          if (not > 50) {
            let can = document.getElementById('orgVehiclesStatus') as HTMLElement;
            can.style.height = '700px'
          }


          res.children.forEach(function (datum: any, index: number) {
            index % 1 === 0 && (datum.collapsed = true);
          });
          return {
            tooltip: {
              trigger: 'item',
              triggerOn: 'mousemove',
              responsive: true,
              textStyle: {
                color: '#000',
                fontFamily: 'vazir',
                fontSize: 12
              },
              formatter: function (params: any) {
                return `تعداد ${new Number(params.data.value).toLocaleString('fa-ir')} زیر مجموعه`
              }
            },
            series: [
              {
                type: 'tree',
                data: [res],
                top: '1%',
                left: '10%',
                responsive: true,
                bottom: '5%',
                right: '20%',
                symbolSize: 10,
                label: {
                  position: 'left',
                  fontFamily: 'vazir',
                  verticalAlign: 'middle',
                  align: 'right',
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#000',
                },
                leaves: {
                  label: {
                    position: 'right',
                    verticalAlign: 'middle',
                    align: 'left',
                    color: '#000'
                  },
                },
                expandAndCollapse: true,
                animationDuration: 550,
                animationDurationUpdate: 750,
              },
            ],
          };
        }),
      );
  }

  getMobilesFullReport = async () => {

    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;

    model.iMobileDomain = this.iMobileDomain;

    model.tiMobileType = this.tiMobileType;

    model.strSDate = this.dataFrom.controls["date"].value;

    model.strEDate = this.dataTo.controls["date"].value;

    model.strSTime = $("#Stime").val();

    model.strETime = $("#Etime").val();

    const resp = await axios.post(`Report_MobilesFullReport`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }

    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '34' } });

      return;
    }

    this.obj1 = resParse;

    this.label1 = [];

    this.datachart1 = [];

    this.obj1.forEach((element: any) => {
      this.label1.push(element.X);
      this.datachart1.push(element.Y);
    });

    const ctx = document.getElementById('myChart1') as any;

    if (this.ctx1) {
      this.ctx1.destroy();
    }

    this.ctx1 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label1,
        datasets: [
          {
            // label: '# of Votes',
            data: this.datachart1,
            backgroundColor: Object.values(this.CHART_COLORS3),

            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      },
    });


  }

  getBoat_Prolific = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    } as any;

    model.iMobileDomain = this.iMobileDomain;

    model.tiMobileType = this.tiMobileType;

    model.strSDate = this.dataFrom.controls["date"].value;

    model.strEDate = this.dataTo.controls["date"].value;

    model.strSTime = $("#Stime").val();

    model.strETime = $("#Etime").val();

    const resp = await axios.post(`Boat_Prolific`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {

      this.notifyService.showError(resParse.strError);

      return;

    }

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '34' } });

      return;

    }

    this.obj2 = resParse;

    this.label2 = [];

    this.datachart2 = [];

    this.obj2.forEach((element: any) => {

      this.label2.push(element.X);

      this.datachart2.push(element.Y);

    });

    const ctx = document.getElementById('myChart2') as any;

    if (this.ctx2) {

      this.ctx2.destroy();

    }

    this.ctx2 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: this.label2,

        datasets: [
          {
            // label: '# of Votes',

            data: this.datachart2,

            backgroundColor: Object.values(this.CHART_COLORS3),


            borderWidth: 1,

          },

        ],

      },

      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      },
    });


  }

  getPowerStatus = async () => {

    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;

    model.iMobileDomain = this.iMobileDomain;

    model.tiMobileType = this.tiMobileType;

    const resp = await axios.post(`Report_PowerStatus`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {

      this.notifyService.showError(resParse.strError);

      return;

    }

    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '57' } });

      return;
    }

    this.obj3 = resParse;

    this.obj3.forEach((element: any) => {

      this.label3.push(element.X);

      this.datachart3.push(element.Y);

    });

    var canvas = document.getElementById("myChart3") as any;

    var ctx = canvas.getContext("2d");

    const DATA_COUNT = 5;

    const data = {

      labels: this.label3,

      datasets: [

        {
          data: this.datachart3,

          backgroundColor: Object.values(this.CHART_COLORS3),

        },
      ],

    } as any;

    if (this.ctx3) {

      this.ctx3.destroy();

    }

    this.ctx3 = new Chart(ctx, {

      type: 'pie',

      data: data,

      options: {

        onClick: (e) => {

          // const points = this.ctx3.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);

          // const firstPoint = points[0];

          // const label = this.ctx3.data.labels[firstPoint.index];

          // const value = this.ctx3.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];

          // this.fileName = "نمودارد وضعیت خودروها.xlsx";

          // this.carStatus(1, label);

        },
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'top',
            labels: {
              color: "black",
            }
          },
          title: {
            display: false,
          },
        },

      },
    });

    var chartEl = document.getElementById("myChart3") as any;

    chartEl.height = 200;

  }

  initializeMap = async () => {

    setTimeout(() => {

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );

      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector)

      }
      if (this.map?.frameIndex_) {

        this.map.setTarget(null);

      }

      this.map = new Map({

        target: "test",

        view: new View({

          zoom: 4,

          center: olProj.fromLonLat(this.location)

        }),

        layers: this.layers

      });

      this.clusterData();

    }, 300);

  }

  clusterData = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    } as any;

    model.iMobileDomain = this.iMobileDomain;

    model.tiMobileType = this.tiMobileType;

    const resp = await axios.post(`Report_MobileCluster`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {

      this.notifyService.showError(resParse.strError);

      return;

    }

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '36' } });

      return;
    }

    this.clustersLayer(resParse);

  }

  clustersLayer(data: any) {
    setTimeout(() => {
      this.map.on('click', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }

        var el = this.mapService.mapPointerMove(
          this.map.getEventPixel(e.originalEvent),
          this.map
        );
        this.showData(el);
        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.map.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;

    // Addfeatures to the cluster
    let addFeatures = (nb: any) => {
      var ext = this.map.getView().calculateExtent(this.map.getSize());
      var features = [];

      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          // new Point (this.mapService.transformCoordinates2([
          //   data[i].dLongitude,
          //   data[i].dLatitude])

          // ),
          // data: data,
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([
            data[i].dLongitude,
            data[i].dLatitude])

          ),
          id_: data[i].strUnitId,
          data: {
            Id: data[i].strUnitId,
            strFullName: data[i].strFullName,
            strDate: data[i].strDate,
            strMobile: data[i].strMobile,
            strTime: data[i].strTime,
            strVehicleNo: data[i].strVehicleNo,
            strMobileType_strComment: data[i].strMobileType_strComment,


            // html: `${data[i].strFullName}`,
          },
        });
        features[i].set("id", i);
      }
      clusterSource.getSource().clear();
      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.map.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.map.addInteraction(selectCluster);


  }

  showData(item: any) {
    var tooltip = $('#map_tooltip');
    tooltip.tooltip({
      html: true,
      animation: true,
      trigger: 'manual',
      placement: 'top',
    });
    tooltip.css({
      left: item.pixel[0] + 'px',
      top: item.pixel[1] - 14 + 'px',
      zindex: 1000,
    });
    if (item.featureLayer) {
      if (item.featureLayer.feature) {
        if (item.featureLayer.feature.values_.features.length == 1) {
          if (item.featureLayer.feature.values_.features[0].values_.data.strFullName) {
            // $('#carCluster').modal('show');
            // this.clusterModal = item.featureLayer.feature.values_.features[0].values_.data;

          }
        }

        // tooltip
        //   .attr(
        //     'data-bs-original-title',
        //     //item.featureLayer.feature.get('data').html
        //     '<div><h5>hello</h5></div>'
        //   )
        //   .tooltip('show');
        // $("#map-tooltips").click(() => {

        //   this.router.navigate([`/carInfo/${item.featureLayer.feature.get('data').Id}`]);
        //   tooltip.tooltip('hide');

        // });
      }
    } else {
      tooltip.tooltip('hide');
    }
  }

}
